import React, { useState } from "react";
import styles from "./createOptions.module.css";
import FormFields from "components/Form";
import DatePicker from "common/Date";
import SaveButton from "components/SaveButton";
const CreateOptions = ({ setModalIsOpen,handleSave ,scheduled_min_date}) => {
  const [createOptions, setCreateOptions] = useState({type:"published"});

  const handleChange = (label) => (e) => {
    setCreateOptions((prevDetails) => ({
      ...prevDetails,
      [label]: e.target ? e.target.value : e,
    }));
  };

  const Fields = [
    {
      label: null,
      id: "type",
      placeholder: "type",
      type: "radio",
      radioClasses: {
    display: "inline-flex",
        alignItems: "center",
        marginTop: "1.3rem",
      },
      selectedValue: createOptions?.type,
      options: [
        { label: "Save as Draft", value: "draft" },
        { label: "Publish", value: "published" },
        { label: "Schedule For", value: "scheduled" },
      ],
      onChange: handleChange("type"),
    },
  ];

  const firstButtonArgs = {
    label: "Cancel",
    id: "cancel",
    name: "cancel",
    buttonOverrideInlineStyle: { marginRight: "1.6rem" },
    onClick: () => {
      setModalIsOpen();
    },
  };

  const secondButtonArgs = {
    label: "Save",
    id: "published",
    name: "publish",
    type: "submit",
    onClick:(e)=>{
        handleSave(createOptions)}
    // onclick: handleSubmit,
  };

  return (
    <div className={styles.createOptions}>
      {/* <div className={styles.publishEvent}>Publish Your Event</div> */}
      {/* <div className={styles.info}>Go live now and start making money.</div> */}
      {/* <div className={styles.subinfo}>
        Once your event’s published you can announce it to your reps and
        followers, to help boost ticket sales.
      </div> */}
      <FormFields Fields={Fields} />
      <div>
        {createOptions?.type === "scheduled" && (
          <DatePicker
            required={true}
            label={"Schedule"}
            onChange={handleChange("scheduled_at")}
            selected={createOptions?.scheduled_at}
            maxDate={new Date(scheduled_min_date)}
            placeholderText="Choose Date"
          />
        )}
      </div>
      <div style={{display:"flex" ,justifyContent:"center",marginLeft:"12px"}}>
      <SaveButton
        firstButtonArgs={firstButtonArgs}
        secondButtonArgs={secondButtonArgs}
      />
      </div>
    </div>
  );
};

export default CreateOptions;
